import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventName = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['name'] => getEvent(eventKey)(store).name;
